import { render, staticRenderFns } from "./GoodsReceiptCreate.vue?vue&type=template&id=55416572&"
import script from "./GoodsReceiptCreate.vue?vue&type=script&lang=js&"
export * from "./GoodsReceiptCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports